var constants = require('../constants');
var initialState = require('../../initialState');

var facebookLikeModalReducer = function(state, action) {
    switch (action.type) {
        case constants.OPEN_FACEBOOK_LIKE_MODAL:
            return true;
        case constants.CLOSE_FACEBOOK_LIKE_MODAL:
            return false;
        default:
            return state || initialState.showFacebookLikeModal;
    }
}

module.exports = facebookLikeModalReducer;



// WEBPACK FOOTER //
// ./src/common/modules/facebook-like-modal/reducers/facebook-like-modal.js